/* Recent-viewed widget — localStorage-based, max 6 items.
   Auto-tracks elke /products/{handle} bezoek en rendert in [data-recent-viewed] containers. */
(function () {
  const KEY = 'sz_recent_viewed';
  const MAX = 6;

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch { return []; }
  }
  function write(arr) { localStorage.setItem(KEY, JSON.stringify(arr.slice(0, MAX))); }

  // Track current product on PDP
  const m = location.pathname.match(/^\/products\/([^\/?#]+)/);
  if (m) {
    const handle = m[1];
    const ttl = document.querySelector('h1')?.innerText?.trim() || handle;
    const img = document.getElementById('pdp-main-img')?.src
      || document.querySelector('main img')?.src
      || '';
    const price = document.querySelector('[data-pdp-price]')?.textContent?.trim() || '';
    const list = read().filter(p => p.handle !== handle);
    list.unshift({ handle, title: ttl.slice(0, 80), img, price, ts: Date.now() });
    write(list);
  }

  function escapeAttr(s) {
    return String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  function render() {
    document.querySelectorAll('[data-recent-viewed]').forEach(container => {
      const list = read().filter(p => !location.pathname.includes('/' + p.handle));
      if (list.length === 0) {
        container.style.display = 'none';
        return;
      }
      container.style.display = '';
      const wrap = container.querySelector('[data-recent-grid]') || container;
      const html = list.slice(0, MAX).map(p => `
        <a href="/products/${escapeAttr(p.handle)}" class="group block">
          <div class="aspect-square overflow-hidden rounded-2xl bg-[color:var(--paper)] mb-2">
            ${p.img ? `<img src="${escapeAttr(p.img)}" alt="${escapeAttr(p.title)}" loading="lazy" class="w-full h-full object-contain transition-transform duration-500 group-hover:scale-105"/>` : ''}
          </div>
          <h3 class="font-display text-[14px] text-ink leading-[1.3] line-clamp-2">${escapeAttr(p.title)}</h3>
          ${p.price ? `<p class="mt-1 text-[14px] font-semibold text-ink">${escapeAttr(p.price)}</p>` : ''}
        </a>
      `).join('');
      wrap.innerHTML = html;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }
})();
